import { useState, useEffect } from "react";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonBadge from "components/ArgonBadge";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
import { Button } from "@mui/material";
import { Link } from "react-router-dom";
import axios, { baseURL } from "utils/api";

const columns = [
  { name: "sno", align: "center" },
  { name: "Subjects", align: "center" },
  { name: "Board", align: "center" },
  { name: "Classes", align: "center" },
];

const TeachingPreferenceTableData = (id, refresh) => {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (!id) return;

    axios
      .get(`${baseURL}/tutor?id=${id}`)
      .then((res) => {
        console.log("Tutor Details API Response:", res.data);
        const tutor = res.data.data;
        console.log("Tutor Data:", tutor);

        // Yeh tino arrays hain
        const subjects = tutor.subjects || [];
        const boards = tutor.boards || [];
        const classes = tutor.classes || [];

        // Ek combined table banane ke liye rows create karna
        const maxLength = Math.max(subjects.length, boards.length, classes.length);

        const formattedRows = Array.from({ length: maxLength }).map((_, index) => ({
          sno: (
            <ArgonTypography variant="caption" fontWeight="medium" color="text">
              {index + 1}
            </ArgonTypography>
          ),
          Subjects: (
            <ArgonTypography variant="caption" fontWeight="medium" color="text">
              {subjects[index]?.name || "N/A"}
            </ArgonTypography>
          ),
          Board: (
            <ArgonTypography variant="caption" fontWeight="medium" color="text">
              {boards[index]?.name || "N/A"}
            </ArgonTypography>
          ),
          Classes: (
            <ArgonTypography variant="caption" fontWeight="medium" color="text">
              {classes[index]?.name || "N/A"}
            </ArgonTypography>
          ),
        }));

        setRows(formattedRows);
      })
      .catch((err) => {
        console.error("❌ Error fetching tutor teaching preferences:", err);
      });
  }, [id, refresh]);

  return { columns, rows };
};

export default TeachingPreferenceTableData;

// /* eslint-disable react/prop-types */
// // Argon Dashboard 2 MUI components
// import ArgonBox from "components/ArgonBox";
// import ArgonTypography from "components/ArgonTypography";
// import ArgonAvatar from "components/ArgonAvatar";
// import ArgonBadge from "components/ArgonBadge";
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import DeleteIcon from '@mui/icons-material/Delete';

// // Images
// import team2 from "assets/images/team-2.jpg";
// import team3 from "assets/images/team-3.jpg";
// import team4 from "assets/images/team-4.jpg";
// import { Button } from "@mui/material";
// import { Link } from "react-router-dom";

// function Author({ image, name, email }) {

//   return (
//     <ArgonBox display="flex" alignItems="center" px={0.5} py={0.1}>
//       <ArgonBox mr={2}>
//         <ArgonAvatar src={image} alt={name} size="sm" variant="rounded"/>
//       </ArgonBox>
//       <ArgonBox display="flex" flexDirection="column">
//         <ArgonTypography textTransform="none" variant="button" fontWeight="medium">
//           {name}
//         </ArgonTypography>
//         <ArgonTypography variant="caption" color="secondary">
//           {email}
//         </ArgonTypography>
//       </ArgonBox>
//     </ArgonBox>
//   );
// }

// const TeachingPreferenceTableData = {
//   columns: [

//     {name:"sno",align:"center"},
//     {name:"Subjects",align:"left"},
//     {name:"Board", align:"left"},
//     {name:"Classes",align:"left"},

//   ],

//   rows: [
//     {
//       sno:<ArgonTypography variant="caption" fontWeight="medium" color="text">{1}</ArgonTypography>,
//       "Category":<ArgonTypography variant="caption" fontWeight="medium" color="text">{"Mathematics"}</ArgonTypography>,
//       "Board": <ArgonTypography variant="caption" fontWeight="medium" color="text">{"CBSE"}</ArgonTypography>,
//       "Classes": <ArgonTypography variant="caption" fontWeight="medium" color="text">{"10th, 12th"}</ArgonTypography>,
//       "Answer": <ArgonTypography variant="caption" fontWeight="medium" color="text">{"Yes"}</ArgonTypography>,
//       status:(<ArgonBadge variant="gradient" badgeContent="online" color="success" size="xs" container />),
//       // action:( <ArgonTypography component="a" href="#"  variant="caption"  color="secondary" fontWeight="medium">  Edit </ArgonTypography>),
//        action: (
//        <ArgonBox display="flex" alignItems="center" gap={0}>
//            {/* View Icon */}
//             <Button variant="text"  size="large" component={Link} to="/tutors/profile" sx={{minWidth:"12px",p:0}} >
//               <VisibilityIcon color="primary"/>
//             </Button>
//             {/* Delete icon */}
//            <Button variant="text"  size="large" sx={{minWidth:"32px",p:0}}
//            onClick={() =>handleDeleteClick()} >
//              <DeleteIcon color="error"/>
//            </Button>

//          </ArgonBox>
//        ),
//     },
//   ],
// }

// export default TeachingPreferenceTableData;
